
import { UnsupportedBlockError } from 'src/shared/wysiwyg/ultra/UltraBlockProcessing/UnsupportedBlockError';

import { Block, HtmlBlock, IBlockProcessor } from './UltraBlockInterfaces';

export class HTMLBlockProcessor implements IBlockProcessor<HtmlBlock> {

    protected readonly container: HTMLElement;

    constructor(container: HTMLElement) {
        this.container = container;
    }

    async process(block: Block): Promise<string> {
        throw new UnsupportedBlockError(`HTML blocks are not yet supported : ${ block.id}`);
    }
}
